import script from "./SearchTablePane.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchTablePane.vue?vue&type=script&lang=ts&setup=true"

import "./SearchTablePane.vue?vue&type=style&index=0&id=51c8836a&lang=scss"

const __exports__ = script;

export default __exports__